// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_oz-0";